import { render, staticRenderFns } from "./MenuItemAddEdit.vue?vue&type=template&id=5ccb8e44"
import script from "./MenuItemAddEdit.vue?vue&type=script&lang=js"
export * from "./MenuItemAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports